import { Header, Footer } from './Layout';
import { MetaIcons } from './MetaIcons';
import BannerGeoIp, { BannerGeoIpType } from './BannerGeoIp';
import SubscriptionInlineForm from './SubscriptionInlineForm';

const Layout = {
    Header,
    Footer,
    MetaIcons,
    BannerGeoIp,
    BannerGeoIpType,
    SubscriptionInlineForm,
};

export default Layout;